import React from 'react';

export const formatSaleUsd = (amount) =>
  `$${Number(amount).toFixed(2).replace(/\.00$/, '')}`;

const SalePrice = ({ offer }) => (
  <>
    <span className="inline-flex rounded-full bg-[#A44432] px-3 py-1 text-xs font-bold text-white">
      {offer.emphasiseSaving ? `Save ${formatSaleUsd(offer.savingUsd)}` : 'Sale fare'}
    </span>
    <h3 className="mt-4 font-serif text-xl font-bold leading-snug text-[#2D1E17]">{offer.routeLabel}</h3>
    <p className="mt-3 flex flex-wrap items-baseline gap-x-3 gap-y-1">
      <span className="sr-only">Was </span>
      <s className="text-lg text-[#7A6E67]">{formatSaleUsd(offer.wasUsd)}</s>
      <span className="sr-only">Now </span>
      <span className="text-4xl font-bold tracking-tight text-[#A44432]">{formatSaleUsd(offer.saleUsd)}</span>
    </p>
    <p className="mt-2 text-sm text-[#4A3C33]">{offer.unitLabel}</p>
  </>
);

export default SalePrice;
